import AffirmUtils from '@/components/cart/AffirmUtils.js';
import PayBrightUtils from '@/components/cart/PayBrightUtils.js';
import LocationService from '@/services/LocationService';
import CountryUtils from '@/components/commons/CountryUtils.js';

export default class Financing {
  static load(config) {
    if (config && config.affirmEnabled && CountryUtils.US.id === LocationService.getCountryId()) {
      return AffirmUtils.load(config.affirmKey, config.affirmUrl);
    }
    if (config && config.paybrightEnabled && CountryUtils.CA.id === LocationService.getCountryId()) {
      return PayBrightUtils.load(config.paybrightKey, config.paybrightUrl, config.paybrightModalUrl);
    }
  }

  static isEnabled(amount, config) {
    return Financing.isPaybrightEnabled(amount, config) || Financing.isAffirmEnabled(amount, config);
  }

  static isAffirmEnabled(amount, config) {
    return config && config.affirmEnabled && CountryUtils.US.id === LocationService.getCountryId() && 
           Financing.inRange(amount, config.affirmMinAmount, config.affirmMaxAmount);
  }

  static isPaybrightEnabled(amount, config) {
    return config && config.paybrightEnabled && CountryUtils.CA.id === LocationService.getCountryId() && 
           Financing.inRange(amount, config.paybrightMinAmount, config.paybrightMaxAmount);
  }

  static async estimatePayment(amount, config, promo) {
    // if on promo, might have to load diff url
    await Financing.load(config);

    if (Financing.isAffirmEnabled(amount, config)) {
      return AffirmUtils.estimatePayment(amount * 100, config, promo);
    }
    if (Financing.isPaybrightEnabled(amount, config)) {
      return PayBrightUtils.estimatePayment(amount * 100, config, promo);
    }
    return null;
  }

  static inRange(amount, min, max) {
    const amountDollars = amount;
    return amountDollars >= min && amountDollars <= max;
  }
}
